import { axios } from '@/lib/axios';

export const newsLetter = (email: string) => {
  const payload = {
    email: email,
  };
  return axios.post('/customer-api/get-newsletter', payload);
};
